export function getHotelsByResortId(baseUrl, siteId, resortWvId) {
  return fetch(`${baseUrl}/api/get-hotels/${siteId}/${resortWvId}`).then(
    (response) => {
      if (response.status >= 400) {
        throw new Error(
          `Bad response from server while fetching hotels for resortId:${resortWvId}, on siteId:${siteId}`,
        );
      }
      return response.json();
    },
  );
}

export function getRoomTypeInfoByWvIdAndRoomTypeKey(
  baseUrl,
  siteId,
  wvId,
  roomTypeKey,
) {
  return fetch(
    `${baseUrl}/api/get-room-type/${siteId}/${wvId}/${roomTypeKey}`,
  ).then((response) => {
    if (response.status >= 400) {
      throw new Error(
        `Bad response from server while fetching roomType for roomTypeKey: ${roomTypeKey} and wvId:${wvId}, on siteId:${siteId}`,
      );
    }
    return response.json();
  });
}
